// Couleurs et tailles de la Charte apps terrain (inspiration Waze, validée le 22/10/2026).
// Source : Cerveau/04 Tools/Charte apps terrain/Charte apps terrain.md
// Tailwind 2.2 sans JIT : ces valeurs passent en styles en ligne.

export const colors = {
	background: '#F5F6FB',
	surface: '#FFFFFF',
	text: '#0B1033',
	textSecondary: '#3D4660',
	border: '#C9CFDB',
	borderShadow: '#E1E4EE',
	separator: '#DDE1EA',
	primary: '#000095',
	arrival: '#1807FF',
	departure: '#F37F6B',
	free: '#CA4CC7',
	tour: '#FFB82E'
}

export const fontFamily = "'Poppins', ui-sans-serif, system-ui, -apple-system, sans-serif"

export const POPPINS_URL = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap'

// Charge Poppins une seule fois, seulement quand un écran terrain est ouvert
export function loadFieldFont()
{
	if (typeof document === 'undefined')
		return ;
	if (document.getElementById('field-font-poppins'))
		return ;
	const link = document.createElement('link')
	link.id = 'field-font-poppins'
	link.rel = 'stylesheet'
	link.href = POPPINS_URL
	document.head.appendChild(link)
}
